import { render, staticRenderFns } from "./StudentMerger.vue?vue&type=template&id=496bb6fd&"
import script from "./StudentMerger.vue?vue&type=script&lang=js&"
export * from "./StudentMerger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports